// ─────────────────────────────────────────────────────────────
// SITE CONTENT — everything editable lives in this one file.
// Brand assets live in /app/frontend/public/assets/.
// Swap book covers, Amazon links and YouTube IDs below.
// ─────────────────────────────────────────────────────────────

export const SITE = {
  name: "Press to Prevail",
  monogram: "PP",
  tagline: "Faith · Foundation · Focus · Finish",
  email: "connect@presstoprevail.com",
  youtubeUrl: "https://www.youtube.com/@PresstoPrevail",
  logoUrl: "/assets/logo-mark.jpg",
  logoFull: "/assets/logo-press-to-prevail.jpg",
  bannerLines: ["Building Faith,", "Building Purpose,", "Building Lives That Last."],
  stats: [
    { value: "50 Years", label: "Teaching & Ministry" },
    { value: "40+ Years", label: "Construction & Leadership" },
    { value: "1 Message", label: "Build What Lasts" },
  ],
};

export const PRESS = [
  { quote: "A voice that rebuilds what life tried to break.", source: "Faith & Leadership Journal" },
  { quote: "Part sermon, part blueprint — wholly unforgettable.", source: "The Purpose Report" },
  { quote: "The rare speaker who leaves a room stronger than he found it.", source: "Conference Weekly" },
  { quote: "Foundational reading for anyone building a life that lasts.", source: "BookLife Reviews" },
];

export const BOOKS = [
  {
    id: "building-the-perfect-home",
    title: "Building the Perfect Home",
    subtitle: "God's Blueprint for Building a Life That Lasts",
    year: "2025",
    coverUrl: "/assets/cover-building-the-perfect-home.jpg",
    description:
      "What if the experience of constructing a home could reveal the principles that transform a life? Drawing on more than 40 years of residential construction experience and a lifetime of faith, Building the Perfect Home connects lessons learned on the job site with timeless truths. From the architect's vision to the final inspection, each stage reveals powerful principles for developing character, strengthening faith, overcoming obstacles, and understanding who we were created to be. A home is more than walls and a roof. A life is about more than simply getting by. It's about creating something that lasts.",
    overview: [
      "What if the experience of constructing a home could reveal the principles that transform a life?",
      "Drawing on more than 40 years of residential construction experience and a lifetime of faith, Building the Perfect Home connects the lessons learned on a construction site with timeless truths. From the architect’s vision to the final inspection, each stage reveals powerful principles for developing character, strengthening faith, overcoming obstacles, and understanding who we were created to be.",
      "Because a home is more than walls and a roof. And a life is about more than simply getting by. It’s about creating something that lasts.",
    ],
    quote: "Every home begins with a blueprint. Every life needs one, too.",
    awards: ["40+ Years of Homebuilding Wisdom", "Timeless Biblical Principles"],
    amazonUrl: "https://www.amazon.com/dp/B0HFC1ZJ3P",
    kindleUrl: "https://www.amazon.com/dp/B0HFC1ZJ3P?bestFormat=true&k=building+the+perfect+home",
    audibleUrl: "",
  },
  {
    id: "foundation-first",
    title: "Foundation First",
    subtitle: "What You Build On Decides What Survives",
    year: "Coming Soon",
    upcoming: true,
    coverUrl: null,
    description:
      "Before the platform, the podium, the plan — the foundation. The next book in the series goes deeper into the unseen work that everything lasting is built on.",
    quote: "You cannot finish strong what you founded weak.",
    awards: [],
    amazonUrl: "",
    kindleUrl: "",
    audibleUrl: "",
  },
  {
    id: "the-finish-line",
    title: "The Finish Line Faith",
    subtitle: "Starting Is Loud. Finishing Is Legendary.",
    year: "Coming Soon",
    upcoming: true,
    coverUrl: null,
    description:
      "The third book takes on the middle mile — why most people stall before the finish, and how faith carries you through it.",
    quote: "Anybody can start. Prevailing is a decision you make daily.",
    awards: [],
    amazonUrl: "",
    kindleUrl: "",
    audibleUrl: "",
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Faith",
    body: "Everything starts here — the foundation for becoming who God created us to be. Faith gives us the confidence to trust His purpose, pursue what lies ahead, and keep building toward a vision we cannot fully see.",
  },
  {
    number: "02",
    title: "Foundation",
    body: "Character before platform. Roots before reach. We build on what cannot be shaken, because lasting lives require a foundation that can hold.",
  },
  {
    number: "03",
    title: "Focus",
    body: "Distraction is the quiet thief of purpose. Focus is faith with its sleeves rolled up — one thing, done with your whole heart.",
  },
  {
    number: "04",
    title: "Finish",
    body: "Starting is exciting. Finishing takes perseverance. The press is not the punishment — it's part of the path. Keep pressing. Keep building. Prevail.",
  },
];

export const VIDEOS = [
  {
    id: "faith-blueprint",
    topic: "Faith: The Blueprint of Life",
    title: "What Blueprint are you Using?",
    description: "Faith gives us the vision to see beyond where we are and trust the One who knows where we need to go.",
    youtubeId: "XT0Kwrvhfso",
    watchUrl: "https://www.youtube.com/watch?v=XT0Kwrvhfso",
  },
  {
    id: "foundation-building-on",
    topic: "Foundation",
    title: "What Are You Building On?",
    description: "The foundation we build upon determines what can stand when life brings storms, challenges, and unexpected trials.",
    youtubeId: "xqehTiVaw2g",
    watchUrl: "https://www.youtube.com/watch?v=xqehTiVaw2g",
  },
  {
    id: "focus-journey",
    topic: "Focus",
    title: "Focus on Your Journey",
    description: "What you focus on shapes your decisions, your priorities, and ultimately your destination.",
    youtubeId: "L76TpXleKFo",
    watchUrl: "https://www.youtube.com/watch?v=L76TpXleKFo",
  },
  {
    id: "finish-strong",
    topic: "Finishing Your Home",
    title: "Finish!",
    description: "The final touches, daily choices, and commitment to God's blueprint help us become the people He designed us to be.",
    youtubeId: "PVTDMrQ2-p4",
    watchUrl: "https://www.youtube.com/watch?v=PVTDMrQ2-p4",
  },
];

export const KEYNOTES = [
  {
    title: "Faith: The Blueprint of Vision",
    length: "45–60 min",
    body: "Faith gives us the vision to build what we cannot see.",
  },
  {
    title: "Foundation: Built on What Is True",
    length: "40 min + Q&A",
    body: "The right foundation provides stability, establishes direction, and stability for the plan.",
  },
  {
    title: "Focus: Intentional Energy of Daily Discipline",
    length: "45 min",
    body: "Focus in alignment with the plan, eliminate distractions, and move the project forward daily.",
  },
  {
    title: "Finish: Complete What You Started",
    length: "30–45 min",
    body: "Stay with the vision, keep building, and see it through to completion.",
  },
];

export const TIMELINE = [
  { year: "1985", title: "The First Foundation", body: "A homebuilding career begins — one poured footing, one framed wall, one family at a time. Forty years of lessons start stacking up." },
  { year: "2015", title: "Notes Became Chapters", body: "Decades of job-site wisdom and quiet-time journaling begin taking shape as something more: a blueprint for building lives, not just houses." },
  { year: "2025", title: "Building the Perfect Home", body: "The flagship book launches — connecting 40+ years of homebuilding experience with timeless biblical principles." },
  { year: "Next", title: "The Coaching Practice", body: "Small cohorts for people ready to stop patching and start rebuilding — faith, foundation, focus, finish." },
];

export const ARTICLES = [
  { title: "Pressure Doesn't Break Purpose — It Reveals It", outlet: "Faith & Leadership Journal", readTime: "8 min", year: "2025" },
  { title: "The Middle Mile Is Where Faith Is Made", outlet: "The Purpose Report", readTime: "6 min", year: "2024" },
  { title: "Roots Before Reach", outlet: "Conference Weekly", readTime: "5 min", year: "2024" },
  { title: "Notes on Finishing What You Started", outlet: "Personal Essay", readTime: "11 min", year: "2023" },
];

export const REVIEWS = [
  { quote: "Forty years of building homes, and it turns out he was writing this book the whole time.", source: "Master Builder & Early Reader", bookId: "building-the-perfect-home" },
  { quote: "Part builder's manual, part Bible study — I've never read anything like it.", source: "Amazon Verified Review", bookId: "building-the-perfect-home" },
  { quote: "Every chapter ends at the doorstep of your own life. Convicting and hopeful at once.", source: "Small Group Leader", bookId: "building-the-perfect-home" },
  { quote: "We read it as a family before breaking ground on our new home. It changed what we were building.", source: "Reader, Texas", bookId: "building-the-perfect-home" },
];

export const ENQUIRY_TYPES = [
  { value: "keynote", label: "Keynote" },
  { value: "workshop", label: "Workshop" },
  { value: "ministry", label: "Church & Ministry" },
  { value: "coaching", label: "Coaching" },
  { value: "other", label: "Other" },
];
